export default "__VITE_ASSET__BA$6EuXs__"